/**
 * Ticket Constants
 * Centralized constants for ticket status, urgency, and support types
 */

export const TICKET_STATUS = {
  OPEN: 'Open',
  IN_PROGRESS: 'In Progress',
  CLOSED: 'Closed'
};

export const TICKET_STATUS_OPTIONS = [
  { value: 'Open', label: 'Open', color: 'info' },
  { value: 'In Progress', label: 'In Progress', color: 'warning' },
  { value: 'Closed', label: 'Closed', color: 'success' }
];

export const TICKET_URGENCY = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  URGENT: 'URGENT'
};

export const TICKET_URGENCY_OPTIONS = [
  { value: 'LOW', label: 'Low', color: 'info' },
  { value: 'MEDIUM', label: 'Medium', color: 'warning' },
  { value: 'HIGH', label: 'High', color: 'error' },
  { value: 'URGENT', label: 'Urgent', color: 'error' }
];

export const SUPPORT_TYPES = {
  DOMOTICS: 'domotics',
  ACCESS_CONTROL: 'access_control',
  TABLET: 'tablet',
  EMERGENCY_SYSTEM: 'emergency_system',
  IT_PC: 'it_pc',
  OTHER: 'other'
};

export const SUPPORT_TYPE_OPTIONS = [
  { value: 'domotics', label: 'Domotics' },
  { value: 'access_control', label: 'Access Control' },
  { value: 'tablet', label: 'Tablet' },
  { value: 'emergency_system', label: 'Emergency System' },
  { value: 'it_pc', label: 'IT/PC' },
  { value: 'other', label: 'Other' }
];

export const SUPPORT_TYPE_LABELS = {
  domotics: 'Domotics',
  access_control: 'Access Control',
  tablet: 'Tablet',
  emergency_system: 'Emergency System',
  it_pc: 'IT/PC',
  other: 'Other'
};

// Urgency order for sorting
export const URGENCY_ORDER = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
  URGENT: 4
};

// Default filter values
export const DEFAULT_STATUS_FILTER = ['Open', 'In Progress'];
export const DEFAULT_URGENCY_FILTER = '';
export const DEFAULT_SUPPORT_TYPE_FILTER = '';
export const DEFAULT_ROWS_PER_PAGE = 50;
